import { FaCar } from "react-icons/fa"
import { ImAirplane } from "react-icons/im"
import { MdMedicalServices } from "react-icons/md"
import { RiHotelFill } from "react-icons/ri"
import "./PackageCard.styles.css"

const IncludesRow = ({ className, ...props }) => {
  return (
    <div
      className={`apackage__card__includes__row ${className ?? ""}`}
      {...props}
    >
      <div className="apackage__card__includes__title">Incluye</div>
      <div className="apackage__card__includes__item">
        <ImAirplane
          className="apackage__card__includes__icon"
          style={{ transform: "scaleX(-1)" }}
        />
        <span>Vuelos</span>
      </div>
      <div className="apackage__card__includes__item">
        <RiHotelFill className="apackage__card__includes__icon" />
        <span>Hoteles</span>
      </div>
      <div className="apackage__card__includes__item">
        <FaCar className="apackage__card__includes__icon" />
        <span>Transporte</span>
      </div>
      <div className="apackage__card__includes__item">
        <MdMedicalServices className="apackage__card__includes__icon" />
        <span>Asistencia</span>
      </div>
    </div>
  )
}

export default IncludesRow
